import { userConstants } from '../user.constants';

export const currentAccount = (state = {}, action) => {
  switch (action.type) {
    // A 401 logout does not reset the store, so a new session must not inherit the
    // previous session's account through the refresh-failure branch below.
    case userConstants.LOGIN_REQUEST:
    case userConstants.REGISTER_REQUEST:
      return {};
    case userConstants.GET_CURRENT_ACCOUNT_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      };
    case userConstants.GET_CURRENT_ACCOUNT_SUCCESS:
      return action.result;
    case userConstants.GET_CURRENT_ACCOUNT_FAILURE:
      // A failed refresh keeps the loaded account and sets no error: PrivateRoute
      // renders the authenticated tree only while currentAccount.name is set, and
      // Sensors replaces its device list with error. The rejected thunk tells the caller.
      if (state.name) {
        return {
          ...state,
          fetching: false,
        };
      }
      return {
        ...state,
        fetching: false,
        error: action.error.message,
      };
    case userConstants.GET_TASK_STATUS:
      return {
        ...state,
        task_in_progress: true
      };
    case userConstants.GET_TASK_DONE:
      return {
        ...state,
        task_in_progress: false
      };
    default:
      return state;
  }
};
